import { Info, AlertTriangle, CheckCircle } from 'lucide-react';
import { NAVY, AMBER, BORDER_COLOR, BG_FIELD } from '../styles/tokens';

/**
 * Renders a section's content blocks. Supported block types:
 *   { type: 'paragraph', text }
 *   { type: 'subheading', text }
 *   { type: 'steps', items: [...] }          → numbered list
 *   { type: 'list', items: [...] }           → bulleted list
 *   { type: 'note', variant, text }          → callout (info | warning | success)
 */

const NOTE_STYLES = {
  info:    { bg: '#eff6ff', border: '#bfdbfe', color: '#1e40af', Icon: Info },
  warning: { bg: '#fffbeb', border: '#fde68a', color: '#92400e', Icon: AlertTriangle },
  success: { bg: '#ecfdf5', border: '#a7f3d0', color: '#065f46', Icon: CheckCircle },
};

function Block({ block }) {
  switch (block.type) {
    case 'paragraph':
      return (
        <p style={{ fontSize: 14.5, lineHeight: 1.7, color: '#334155', margin: '0 0 14px' }}>
          {block.text}
        </p>
      );

    case 'subheading':
      return (
        <h3 style={{ fontSize: 15, fontWeight: 700, color: NAVY, margin: '20px 0 10px' }}>
          {block.text}
        </h3>
      );

    case 'steps':
      return (
        <ol style={{ margin: '0 0 16px', paddingLeft: 0, listStyle: 'none', counterReset: 'step' }}>
          {block.items.map((item, i) => (
            <li
              key={i}
              style={{
                display: 'flex', alignItems: 'flex-start', gap: 12,
                fontSize: 14.5, lineHeight: 1.6, color: '#334155',
                marginBottom: 10,
              }}
            >
              <span style={{
                flexShrink: 0, width: 24, height: 24, borderRadius: '50%',
                background: BG_FIELD, border: `1px solid ${BORDER_COLOR}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 12, fontWeight: 700, color: AMBER, marginTop: 1,
              }}>
                {i + 1}
              </span>
              <span>{item}</span>
            </li>
          ))}
        </ol>
      );

    case 'list':
      return (
        <ul style={{ margin: '0 0 16px', paddingLeft: 20 }}>
          {block.items.map((item, i) => (
            <li key={i} style={{ fontSize: 14.5, lineHeight: 1.7, color: '#334155', marginBottom: 6 }}>
              {item}
            </li>
          ))}
        </ul>
      );

    case 'note': {
      const s = NOTE_STYLES[block.variant] || NOTE_STYLES.info;
      const { Icon } = s;
      return (
        <div style={{
          display: 'flex', alignItems: 'flex-start', gap: 10,
          background: s.bg, border: `1px solid ${s.border}`, borderRadius: 10,
          padding: '12px 14px', margin: '0 0 16px',
        }}>
          <Icon size={17} color={s.color} style={{ flexShrink: 0, marginTop: 1 }} />
          <span style={{ fontSize: 13.5, lineHeight: 1.6, color: s.color }}>{block.text}</span>
        </div>
      );
    }

    default:
      return null;
  }
}

export default function ManualContent({ blocks }) {
  if (!blocks || blocks.length === 0) {
    return (
      <p style={{ fontSize: 14, color: '#94a3b8', fontStyle: 'italic' }}>
        Contenido en preparación.
      </p>
    );
  }
  return (
    <div>
      {blocks.map((block, i) => <Block key={i} block={block} />)}
    </div>
  );
}
